var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close (2) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.1794 27.9688L8.10102 2.89061C7.00728 1.79688 5.23405 1.79688 4.14202 2.89061L2.8203 4.21026C1.72657 5.30434 1.72657 7.07755 2.8203 8.16957L27.8987 33.2478C28.9928 34.3415 30.766 34.3415 31.8581 33.2478L33.1777 31.9281C34.2735 30.8361 34.2735 29.0626 33.1794 27.9688Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M27.8987 2.89133L2.8203 27.9695C1.72657 29.0633 1.72657 30.8368 2.8203 31.9288L4.13997 33.2485C5.23405 34.3422 7.00728 34.3422 8.09931 33.2485L33.1794 8.172C34.2735 7.07827 34.2735 5.30506 33.1794 4.21304L31.8598 2.89338C30.766 1.7976 28.9928 1.7976 27.8987 2.89133Z",
    fill: "#F44336"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNo);
export default __webpack_public_path__ + "static/media/no.0bec1a0b2e75b7b18ac382f06dae9dab.svg";
export { ForwardRef as ReactComponent };